import Arrow from 'Elements/Link/Arrow';
import styled, { css } from 'styled-components';

export const Container = styled.article`
    ${({ theme }) => css`
        position: relative;
        overflow: hidden;
        background-color: ${theme.colors.primaryContrast.hex};
        border-radius: 0.5rem;
        transform: translateZ(0);
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;

        @media ${theme.breakpoints.large.media} {
            flex-direction: row;
        }
    `}
`;

export const ImageWrapper = styled.div`
    ${({ theme }) => css`
        position: relative;
        width: 101%;
        overflow: hidden;
        flex: 0 0 auto;
        height: 10rem;

        @media ${theme.breakpoints.large.media} {
            margin-bottom: 0.5rem;
            height: 101%;
            width: 38%;
            margin-bottom: 0rem;
            top: -0.2rem;
        }
    `}
`;

export const Hr = styled.hr`
    ${({ theme }) => css`
        width: 100%;
        color: ${theme.colors.secondary.tints[1].hex};
        opacity: 0.3;
        height: ${theme.commonStyles.brandPixel};
        margin: 0.5rem 0;

        @media ${theme.breakpoints.medium.media} {
            margin: 1rem 0;
        }

        @media ${theme.breakpoints.large.media} {
            margin: 0.5rem 0 1.5rem;
        }
    `}
`;

export const Avatar = styled.div`
    ${({ theme }) => css`
        position: relative;
        border-radius: 50%;
        transform: translateZ(0);
        overflow: hidden;
        width: 4.5rem;
        height: 4.5rem;
        margin-right: 1rem;

        @media ${theme.breakpoints.medium.media} {
            width: 5.5rem;
            height: 5.5rem;
            margin-right: 2rem;
        }
    `}
`;

export const Quote = styled.blockquote`
    ${({ theme }) => css`
        display: flex;
        align-items: center;
        margin: 0;
        font-family: ${theme.fonts.secondary};
        line-height: 1.2;
        font-size: 1.125rem;
        padding-right: 0.5rem;
        overflow: hidden;
        height: 5.5rem;

        @media ${theme.breakpoints.medium.media} {
            font-size: 1.375rem;
            padding-right: 2rem;
            height: 5rem;
        }

        @media ${theme.breakpoints.large.media} {
            font-size: 1.75rem;
            padding-right: 0;
            height: 10.44rem;
        }
    `}
`;

export const ResponsiveLinkWrapper = styled.div`
    ${({ theme }) => css`
        margin-top: 0.25rem;

        @media ${theme.breakpoints.medium.media} {
            display: none;
        }

        @media ${theme.breakpoints.large.media} {
            display: block;
        }
    `}
`;

export const LinkWrapper = styled.div`
    ${({ theme }) => css`
        display: none;
        align-items: center;

        @media ${theme.breakpoints.medium.media} {
            display: flex;
        }

        @media ${theme.breakpoints.large.media} {
            display: none;
        }
    `}
`;

export const BioContainer = styled.div`
    ${({ theme }) => css`
        position: relative;
        display: flex;

        @media ${theme.breakpoints.medium.media} {
            justify-content: space-between;
        }
    `}
`;

export const StudentContainer = styled.div`
    ${({ theme }) => css`
        display: flex;
        flex-direction: column;
        padding: 1rem 1rem 1rem 1rem;

        @media ${theme.breakpoints.medium.media} {
            padding: 1rem 1rem 1rem 1.5rem;
        }

        @media ${theme.breakpoints.large.media} {
            padding: 1.7rem 1.5rem 1.7rem;
            width: 62%;
        }
    `}
`;

export const Heading = styled.h3`
    ${({ theme }) => css`
        font-family: ${theme.fonts.secondary};
        font-weight: 300;
        font-size: 1.375rem;
        margin-top: 0.5rem;
        line-height: 1;
        margin-bottom: 0;

        @media ${theme.breakpoints.large.media} {
            font-size: 1.75rem;
            margin-bottom: inherit;
            line-height: inherit;
        }
    `}
`;

export const Position = styled.p`
    ${({ theme }) => css`
        font-weight: bold;
        margin: 0;
        line-height: 1.1;
        font-size: 1rem;

        @media ${theme.breakpoints.large.media} {
            font-size: 1.125rem;
        }
    `}
`;

export const Organisation = styled.p`
    ${({ theme }) => css`
        margin: 0;
        line-height: 1.1;
        font-size: 1rem;

        @media ${theme.breakpoints.large.media} {
            font-size: 1.125rem;
        }
    `}
`;

export const DetailsContainer = styled.div`
    display: flex;
    align-items: center;
`;

export const Link = styled(Arrow)`
    ${({ theme }) => css`
        font-size: 1.125rem;

        @media ${theme.breakpoints.large.media} {
            font-size: 1.25rem;
        }
    `}
`;
